export default __webpack_public_path__ + "static/media/2740.60b921ae.svg";